/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.resources.personnel.list.controllers', [])

.controller('ResourcesPersonnelListController', ['$scope', function($scope) {

    $scope.resourcesPersonnelList = {
      init: function() {
        $scope.$emit('Application::contentTitleChange', {
          title: 'Personnel Manager'
        });
      }
    };

    $scope.resourcesPersonnelList.init();

}]);